/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { StyleModal } from '../../modal/styles';
import { WrapperServices } from './styles';
import TableComparative from '../../dashboard/table/tableComparative';
import NodesModal from '../../dashboard/table/nodesModal';
import { getNodesPerCategory } from '../../../store/fuse/monitoreo';
import utils from '../utils';

const { COLOR_MAP } = utils;

const Index = (props) => {
  const { services } = props;
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const loadingNodes = useSelector((state) => state.fuse?.monitoreo?.loadingNodes);
  const nodesData = useSelector((state) => state?.fuse?.monitoreo?.nodes);
  const filtersSelected = useSelector((state) => state?.fuse?.monitoreo?.filtersSelected);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const handleDeviceClick = (data, color) => {
    dispatch(getNodesPerCategory('service', data.tiposervicioid, color, filtersSelected));
    setOpen(true);
  };

  return (
    <WrapperServices>
      <div
        className="w-full flex flex-col justify-around m-10 rounded-lg mt-0"
        style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
      >
        <div className="text-service">
          <h2>Servicios</h2>
          <h4>Total de Dispositivos</h4>
        </div>
        <div className="flex flex-row section-flex">
          {services?.map((data, index) => (
            <div className="section-point" key={index}>
              <div className="section-service">
                <strong>{data.dstiposervicio}</strong>
              </div>
              <div className="section-percentage">
                {data.verde !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.verde !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.verde, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'verde');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'verde');
                        }}
                      />
                    </div>
                    {data.verde}
                  </div>
                )}
                {data.amarillo !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.amarillo !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.amarillo, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'amarillo');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'amarillo');
                        }}
                      />
                    </div>
                    {data.amarillo}
                  </div>
                )}
                {data.rojo !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.rojo !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.rojo, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'rojo');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'rojo');
                        }}
                      />
                    </div>
                    {data.rojo}
                  </div>
                )}
                {data.gris !== '0' && (
                  <div>
                    <div>
                      <div
                        className={`rounded-div ${data.gris !== '0' ? '' : 'unclickable-indicator'}`}
                        style={{ background: COLOR_MAP.gris, cursor: 'pointer' }}
                        onClick={() => {
                          handleDeviceClick(data, 'gris');
                        }}
                        onKeyDown={() => {
                          handleDeviceClick(data, 'gris');
                        }}
                      />
                    </div>
                    {data.gris}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={StyleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ margin: '0px 0px 15px 0px' }}>
            Métricas
          </Typography>
          <Typography id="modal-modal-description" style={{ margin: '0px 0px 10px 0px' }}>
            Nombre: <strong> {nameDevice} </strong> <br />
            Cantidad:<strong> {countData} </strong> <br />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Semaforo: <div style={{ background: colorDevice, borderRadius: '50%', height: '20px', width: '20px', margin: '4px' }} />
            </div>
          </Typography>
          <TableComparative />
          <div style={{ margin: '15px 15px 0px', display: 'flex', justifyContent: 'end' }}>
            <Button variant="contained" style={{ backgroundColor: 'green', color: 'white' }}>Descargar excel</Button>
          </div>
        </Box>
      </Modal> */}
      <NodesModal openModal={open} handleCloseModal={handleClose} loading={loadingNodes} nodesData={nodesData} redirectPath="/monitoreo" />
    </WrapperServices>
  );
};

export default Index;
